/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_V2_Upload_Document_HintInputs */

const en_home_v2_upload_document_hint = /** @type {(inputs: Home_V2_Upload_Document_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF, DOCX, EPUB or TXT`)
};

const es_home_v2_upload_document_hint = /** @type {(inputs: Home_V2_Upload_Document_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF, DOCX, EPUB o TXT`)
};

/**
* | output |
* | --- |
* | "PDF, DOCX, EPUB or TXT" |
*
* @param {Home_V2_Upload_Document_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_upload_document_hint = /** @type {((inputs?: Home_V2_Upload_Document_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_Upload_Document_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_upload_document_hint(inputs)
	return en_home_v2_upload_document_hint(inputs)
});